// extracted by mini-css-extract-plugin
module.exports = {"reviewCardOuter":"k-HUu","cardMediaContainer":"_1FtRM","cardHeading":"_4jKFa","cardAmount":"_3E0BE","amount":"_3iNUt"};